import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Webcamp Zagreb report",
  "description": "",
  "published": "2012-11-27T00:00:00.000Z",
  "redirect_from": ["/blog/webcamp-zagreb-report/swizec/5603"],
  "categories": "Croatian, Croatian language, Erlang, Programming, Scala, Travel + Events, Zagreb",
  "hero": "./img/tumblr_mdzjxabM2O1qekjngo1_500.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`How do you get a hardened night owl to wake up before it's light out? You promise a cool geek event.`}</p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "500px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/f7a9b5fd2136c6fad3a6971c1fd85c2b/41099/tumblr_mdzjxabM2O1qekjngo1_500.jpg",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "100%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'400\\'%20viewBox=\\'0%200%20400%20400\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%2014v14h8c8%200%209%201%206%204l-2%202h2l3-2c0-4%201-4%2011-4s11%200%208%204c-2%202-2%202%200%202l3-3%202-3h9c10%200%2011%201%208%204-2%202-3%203%200%202l3-3c2-3%202-3%2012-3%205%200%209%200%208-1l-2-1c0-2%203-1%205%201l3%202-1-2c-3-2%206-2%2056-2l183%203%205%201%201%206%202%206%2014%201a275%20275%200%200127%201l3-29V0H0v14m378%202l-2%2022c-1%205-1%206%202%208l5%209a877%20877%200%200017%2037V0h-22v16M6%2076l1%201c2-1%206%200%206%201%200%202-9%2012-11%2012l-1%201c0%202%204%201%205-1%201-1%201-1%202%201s2%202%2015%202c15%200%2015%200%2020-7%206-7%204-8-2-1l-5%206-13-1-15-1%203-5%204-5%202-1c2-1%202-1%201-2H6m35%2015v2a361%20361%200%200048%200l-48-2M0%2099v5h12c50%201%2059%200%2059-3l-6-1c-3%200-4%200-3-1l2-1-50-4H0v5m38%209l-20%2018-18%2017v23h9c7%200%209%200%208-1l-5-1-4-1%201-1h2v-1c-1-1%200-1%202-1h3v-5l1-6%201-3%202-2c2%200%204-4%204-9v-5c1-2%201-2%201%202%200%203%200%204%202%204s2-1%202-4%200-4%202-4l1-1-1-1c-2%200-1-3%201-3s3-1%203-2c0-2%200-3%202-3%203%200%203-2%200-2-2-1-3-4%200-4h2v2l1%204c1%201%204%202%204%200l-2-2c-3-2%203-5%2010-5h5l-5-1-4-1h4c7%200%208%200%206-1H38m230%201c0%202%202%202%2034%203%2031%201%2035%201%2035-3h-1a421%20421%200%2001-68%200M17%20182H0v218h376v-4l2-11a249%20249%200%20015-36c0-2%200-3%203-2l2%202c0%202%200%202-1%201h-3l1%201c2%200%205%203%204%204l3%201c2%200%203%200%202%201l2%205%201-1v-2c2%200%203%204%201%205v2c0%202%200%202%201%201s1-1%201%201l-1%202v7c1%201%200%202-2%202-3%200-4%202-1%203l2%201-8%203-2%201%202%201%202%201-4%201c-4-1-5%200-2%201%202%201%200%203-2%203l-2%201-1%203c0%202%201%202%2010%202h10V290l-1-96v13h-4l-118-7c-29-3-27-3-28%204l-2%207-1%208c-1%208-2%2010-3%209l-2%203-2%206-2%204c1%201%200%202-1%202l-5%204c-4%204-8%206-8%204l-3%201-8%201-5%201c0%202-6%204-11%204l-5%201-24%201-24-1-4-1-4-1-5-1-7-1-7-2c-9-2-17-7-26-15l-7-5-1-1-1-3-3-4a637%20637%200%2000-11-30c-1%201-48-3-49-5-2-2-1-2%208-1h21l17%201c4%201%204%200%201-4-2-3-3-3-22-4H17m378%2058l-1%2021c0%206%200%206%202%206%204%200%203%200%204-21l-1-19c-1%200-2%203-4%2013m-46%2026v5l-1%206v9c1%200%202-1%202-3%201-2%202-2%202-1l2%202c3%200%203-3%200-4-2%200-2%200-1-1l2-2%202-3c2-1%202-5%202-9h-6c0-1-4-1-4%201m14%200c-1%202-2%2018-1%2020v2c-1%201%200%201%202%201%204-1%205-2%204-5l1-3%202-3c3-7%205-4%205%207%200%207%200%209%202%2011%202%203%203%202%204-5a2709%202709%200%20014-24c-1-2-6-1-7%202-2%203-4%202-5-1%200-3-9-4-11-2\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/f7a9b5fd2136c6fad3a6971c1fd85c2b/ca0a1/tumblr_mdzjxabM2O1qekjngo1_500.webp 223w", "/static/f7a9b5fd2136c6fad3a6971c1fd85c2b/75680/tumblr_mdzjxabM2O1qekjngo1_500.webp 445w", "/static/f7a9b5fd2136c6fad3a6971c1fd85c2b/b0a15/tumblr_mdzjxabM2O1qekjngo1_500.webp 500w"],
                "sizes": "(max-width: 500px) 100vw, 500px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/f7a9b5fd2136c6fad3a6971c1fd85c2b/853b2/tumblr_mdzjxabM2O1qekjngo1_500.jpg 223w", "/static/f7a9b5fd2136c6fad3a6971c1fd85c2b/0a4fe/tumblr_mdzjxabM2O1qekjngo1_500.jpg 445w", "/static/f7a9b5fd2136c6fad3a6971c1fd85c2b/41099/tumblr_mdzjxabM2O1qekjngo1_500.jpg 500w"],
                "sizes": "(max-width: 500px) 100vw, 500px",
                "type": "image/jpeg"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/f7a9b5fd2136c6fad3a6971c1fd85c2b/41099/tumblr_mdzjxabM2O1qekjngo1_500.jpg",
                "alt": "Orange juice in lieu of tea",
                "title": "Orange juice in lieu of tea",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`Orange juice in lieu of tea`}</figcaption>{`
  `}</figure></p>
    <p>{`On Saturday I went to Webcamp `}<a parentName="p" {...{
        "href": "http://maps.google.com/maps?ll=45.8166666667,15.9833333333&spn=0.1,0.1&q=45.8166666667,15.9833333333%20(Zagreb)&t=h",
        "title": "Zagreb"
      }}>{`Zagreb`}</a>{` with `}<a parentName="p" {...{
        "href": "https://twitter.com/hairyfotr"
      }}>{`@HairyFotr`}</a>{` and two lasses who wanted to tourist around Zagreb while the boring geeks do their thing. After the `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Global_Positioning_System",
        "title": "Global Positioning System"
      }}>{`GPS`}</a>{` sent us to a strange settlement some 20 kilometers outside Zagreb, after stumbling around Zagreb for an hour we finally found the Webcamp.`}</p>
    <p>{`Only an hour late!`}</p>
    <p>{`The event was your usual barcamp with two tracks, a break room and a comically tiny hall between the two rooms. Gridlock after every talk! Started wondering if the talks were purposefully scheduled so that the people who would like a certain talk would almost definitely have to move ot the other room for the next one.`}</p>
    <p>{`At least that's what seems to have been happening ...`}</p>
    <p>{`Unfortunately, all talks save mine were in `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Croatian_language",
        "title": "Croatian language"
      }}>{`Croatian`}</a>{`. I `}<em parentName="p">{`think`}</em>{` I understood everything, but there's simply no way of knowing for sure. At one point it felt like the talks weren't technical enough ... I probably just set too high expectations in my mind when reading the Croatian descriptions.`}</p>
    <p>{`Only picking out the English buzzwords will do that to you.`}</p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "500px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/aae2a7599329002a23d47659b0bb5397/41099/tumblr_mdzxtn6Ofs1qekjngo1_500.jpg",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "100%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'400\\'%20viewBox=\\'0%200%20400%20400\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%20200v200h401V0H0v200m134-57v3a768%20768%200%2000-2%2035c0-6-2-6-2%200%200%202%200%203-1%202a3829%203829%200%2000-3-7l-2-1-3-1-13-4h-2l-2-1c-1-1-1-1-1%201l-1-2-1-4v8l-1-4c-1-7-2%209-2%2038v25h63l-1%2025-1%2025%201%202c3%202%204%202%2021%200%2010%200%208-1-3-1l-8-1%2010-1c8%200%209%200%209%202l9%201a5115%205115%200%2001157-7c-5%200-5%200-2-1l3-1%205-29%202-13c1-1%201-2-1-4-2-3-2-3-1-4v-2l-1-4-7-18-1-4v-4l-1%203a1318%201318%200%2000-7-47v-4h-45c-107-2-165-2-165-1m-47%2030c0%202%200%202-1%201-2-1-26-2-26%200l11%201c10%200%2013%201%2012%203-2%201-25%202-27%201h-1l1%202-4-1c-3-1-9%200-9%202l6%2014%202%207%201%204c2%201%202%201%204-1l3-5c0-2%201-1%203%202l3%203c2%200%203%202%200%202-1%201%200%201%203%201l4%201h1c2-3%203-2%205%202l2%204a652%20652%200%20014%2059l1%203%201%203%201-3c0-6%201-13%202-10l2-27a415%20415%200%2000-1-67v-2l-1%202-1%203v-3c-1-3-1-3-1-1m186%20123a1424%201424%200%2000-97%204l-8-1v-1l3%2015c3%2012%203%2016%204%2031l1%2013v-3h8l8-1-1-1c-2%200-2-1-1-4l2-2%201-1c0-2%206-9%208-9l4-1%2012-4%201%201%202-6%201-6%208-1h9l-4-11c-3-2-2-6%200-6%201%200%202%201%202%203l3%209%201%205h11a306%20306%200%200028-1l1%201v1h7l12-1c4%200%205%200%206-2%200-2%201-2%202-1h1l1%201c1%201%201%200%201-5v-7h16l13-1c-3-1-3-1-1-1%204%200%205-2%200-3-3%200-4-1-5-2v-2h-60m-116%204h-5l-2%201h-2a69646%2069646%200%20014%2053c0%204%203%207%204%205h14v-2l1%202c1%201%201-4%201-14%200-15-2-28-6-40-2-6-2-6-9-5m-20%202l-3%201%202%201h1c0-2%202%200%202%202s-2%204-3%202c-1-1-1-1-1%201%200%203-1%202-2-2l-1%2018%201%2022%201%203c0%202%200%202%201-1l1-3%201%202%201%202c1%202%206%204%206%203h1l1%203a221%20221%200%2000-3-52c0-2-1-3-6-2\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/aae2a7599329002a23d47659b0bb5397/ca0a1/tumblr_mdzxtn6Ofs1qekjngo1_500.webp 223w", "/static/aae2a7599329002a23d47659b0bb5397/75680/tumblr_mdzxtn6Ofs1qekjngo1_500.webp 445w", "/static/aae2a7599329002a23d47659b0bb5397/b0a15/tumblr_mdzxtn6Ofs1qekjngo1_500.webp 500w"],
                "sizes": "(max-width: 500px) 100vw, 500px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/aae2a7599329002a23d47659b0bb5397/853b2/tumblr_mdzxtn6Ofs1qekjngo1_500.jpg 223w", "/static/aae2a7599329002a23d47659b0bb5397/0a4fe/tumblr_mdzxtn6Ofs1qekjngo1_500.jpg 445w", "/static/aae2a7599329002a23d47659b0bb5397/41099/tumblr_mdzxtn6Ofs1qekjngo1_500.jpg 500w"],
                "sizes": "(max-width: 500px) 100vw, 500px",
                "type": "image/jpeg"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/aae2a7599329002a23d47659b0bb5397/41099/tumblr_mdzxtn6Ofs1qekjngo1_500.jpg",
                "alt": "Erlang, like life, is made of tiny strings",
                "title": "Erlang, like life, is made of tiny strings",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`Erlang, like life, is made of tiny strings`}</figcaption>{`
  `}</figure><img parentName="p" {...{
        "src": "",
        "alt": null
      }}></img></p>
    <p>{`The best talk, the one that sticks in my mind as `}<em parentName="p">{`"Wow, I learned something new!"`}</em>{` was the Erlang talk by Saša Jurić. Apparently Erlang is very similar to node.js at its core - a single-threaded approach to concurrency via creating micro threads that are run in parallel by a scheduler. It all sounded a bit like somebody took the idea of node.js, added some steroids and a bit of computer craziness. And voila, Erlang - a system for `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Massively_parallel",
        "title": "Massively parallel"
      }}>{`massively parallel`}</a>{` web development.`}</p>
    <p>{`Another cool talk was about the insanity of doing everything on `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Bleeding_edge_technology",
        "title": "Bleeding edge technology"
      }}>{`bleeding edge`}</a>{` technologies. More of a cautionary tale than really educational, but the presenter did a remarkable job of keeping me interested without `}<em parentName="p">{`really`}</em>{` telling me much I don't know anyway.`}</p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "500px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/ea8e8b7eb0d565d36e69ce4335266b5c/41099/tumblr_mdzzqbcZq21qekjngo1_500.jpg",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "100%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'400\\'%20viewBox=\\'0%200%20400%20400\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%20200v200h401V0H0v200M172%2058l-1%202c1%201-2%204-4%204l-1-2h-1v3c0%201-5%205-9%205-11%202-15%204-15%207l-2%201-6%203-5%204c-3%201-4%203-1%203l-1%202-2%202%202%202c4%203%2040%204%20105%203%2047-1%2053-2%2048-8-3-3-7-4-7-2l-1-1c-2-2-2-2-3-1-1%203-2%202-3-1l-1-1-4-1c-3-2-4-2-4-1%200%203-3%202-4-1l-3-2c-6%201-9%200-9-1%200-2-2-4-3-2s-3%200-4-6c0-7-2-5-1%203v6l-19-1a102%20102%200%2001-21-1l-3%201c-2%200-2%200%201-2%202-2%204-3%203-4h3c1%202%202%200%201-4l-1-3-1%203-1%203v-3c0-3-1-4-2-2h-1c0-2-5-4-7-3l-2-1c-1-1-1-1-1%201l2%205c0%202%200%202-1%201-1-2-1-2-1%200v3l-1-3-3-7c-1-4-4-5-5-3m-19%2043l-3%201h7l-5%202-15%202-11%202h13a3338%203338%200%2000116-1l-26-1%203-1-4-1-3-1h-4l-5-1h-2a574%20574%200%2000-60-1m16%2010l-13%201c-1%201-9%202-26%202h-25v3l-7%20111v15h11l25%201%2014%201v-5l1-5-17-2-17-1%2017-1c17%200%2018%200%2018-5%200-2-3-3-12-2v-18h12l13-1c1-1-1-1-10-1-7%200-10%200-8-1h-1l-5-1h-3l-2-1v1c1%201-1%201-8%201s-9-1-9-2l25-1h26v-4c-3-4-2-8%201-12l2-4c6-2%209-1%2013%203s5%206%203%2014c-2%205-1%208%202%208s8%205%209%2010c2%209%2010%2030%2011%2031a8805%208805%200%200197%204l10%201v-12c0-1%202-2%205-2s4-1%204-4c0-4%202-8%204-8l1-1-6-1-7-1v-6a394%20394%200%20011-56l-1-22v-22l-45-1a945%20945%200%2001-103-4M21%20122l-1%2010-4%2040c0%201%201%202%204%202s4%200%204-2l1-3%202-32c-1-6-5-17-6-15\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/ea8e8b7eb0d565d36e69ce4335266b5c/ca0a1/tumblr_mdzzqbcZq21qekjngo1_500.webp 223w", "/static/ea8e8b7eb0d565d36e69ce4335266b5c/75680/tumblr_mdzzqbcZq21qekjngo1_500.webp 445w", "/static/ea8e8b7eb0d565d36e69ce4335266b5c/b0a15/tumblr_mdzzqbcZq21qekjngo1_500.webp 500w"],
                "sizes": "(max-width: 500px) 100vw, 500px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/ea8e8b7eb0d565d36e69ce4335266b5c/853b2/tumblr_mdzzqbcZq21qekjngo1_500.jpg 223w", "/static/ea8e8b7eb0d565d36e69ce4335266b5c/0a4fe/tumblr_mdzzqbcZq21qekjngo1_500.jpg 445w", "/static/ea8e8b7eb0d565d36e69ce4335266b5c/41099/tumblr_mdzzqbcZq21qekjngo1_500.jpg 500w"],
                "sizes": "(max-width: 500px) 100vw, 500px",
                "type": "image/jpeg"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/ea8e8b7eb0d565d36e69ce4335266b5c/41099/tumblr_mdzzqbcZq21qekjngo1_500.jpg",
                "alt": "A hardened bleeding edge veteran",
                "title": "A hardened bleeding edge veteran",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`A hardened bleeding edge veteran`}</figcaption>{`
  `}</figure></p>
    <p>{`The fact they're using `}<a parentName="p" {...{
        "href": "http://www.scala-lang.org/",
        "title": "Scala (programming language)"
      }}>{`Scala`}</a>{` in production put a bit of a damper on their message. Or made it into a good war story. Hard to say.`}</p>
    <p>{`As for my own talk, I think it went well. Considering my vision was swimming from a brain splitting headache and I could barely speak without slurring it went really quite remarkably well. And I only forgot one point I wanted to make. Success.`}</p>
    <p>{`All in all, 8/10, would go again!`}</p>
    <p><a parentName="p" {...{
        "href": "https://speakerdeck.com/swizec/why-programmers-work-at-night"
      }}>{`https://speakerdeck.com/swizec/why-programmers-work-at-night`}</a></p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.101greatgoals.com/blog/croatian-wonderkid-alen-halilovic-produces-one-of-the-worst-dives-ever/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/128271441_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://www.101greatgoals.com/blog/croatian-wonderkid-alen-halilovic-produces-one-of-the-worst-dives-ever/"
        }}>{`Croatian wonderkid Alen Halilovic produces one of the worst dives EVER`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://europeinside.org/2012/11/27/croatia-next-member-of-the-european-union-alessandro-virciglio/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/128352604_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://europeinside.org/2012/11/27/croatia-next-member-of-the-european-union-alessandro-virciglio/"
        }}>{`Croatia, next member of the European Union - Alessandro Virciglio`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://the.taoofmac.com/space/dev/Erlang"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/noimg_104_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://the.taoofmac.com/space/dev/Erlang"
        }}>{`Erlang`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://highscalability.com/blog/2012/11/26/bigdata-using-erlang-c-and-lisp-to-fight-the-tsunami-of-mobi.html"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/128195499_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://highscalability.com/blog/2012/11/26/bigdata-using-erlang-c-and-lisp-to-fight-the-tsunami-of-mobi.html"
        }}>{`BigData using Erlang, C and Lisp to Fight the Tsunami of Mobile Data`}</a></li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/?px",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=67decf91-4d62-46a9-999c-5194cd484855",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      